import { Controller } from "stimulus"
import StimulusReflex from "stimulus_reflex"

export default class extends Controller {
  connect() {
    StimulusReflex.register(this)
    this.initializeCriteriaSection();
  }

  afterReflex() {
    // Valider le formulaire après chaque mise à jour Reflex
    validateForm();
  }

  initializeCriteriaSection() {
    const amountField = this.element.querySelector('#subscription_amount');
    if (amountField && amountField.value) {
      this.stimulate('SubscriptionamountReflex#validate', amountField);
    }
  }
}
